export const movies = [
  {
    id: "10001",
    title: "长夜将明",
    type: "movie",
    region: "中国大陆",
    year: 2024,
    genres: ["剧情", "悬疑"],
    rating: 8.7,
    views: 1284567,
    duration: "128分钟",
    actors: ["张启明", "林晚秋", "周正阳"],
    director: "陈默",
    description:
      "一桩尘封十年的旧案重新浮出水面，退休刑警在长夜中追寻真相，却发现每个知情者都藏着不愿被揭开的秘密。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20a%20lone%20detective%20on%20a%20rain%20soaked%20neon%20city%20street%20at%20night%2C%20deep%20blue%20tones%2C%20dramatic%20lighting%2C%20moody%20cinematic%20color%20grade%2C%20no%20text&width=400&height=600&seq=cover-10001&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20rainy%20city%20skyline%20at%20night%20with%20wet%20reflections%2C%20deep%20blue%20and%20teal%20tones%2C%20dramatic%20lighting%2C%20no%20text&width=1600&height=900&seq=bd-10001&orientation=landscape",
    featured: true,
  },
  {
    id: "10002",
    title: "星际回响",
    type: "movie",
    region: "美国",
    year: 2024,
    genres: ["科幻", "冒险"],
    rating: 9.1,
    views: 2431890,
    duration: "145分钟",
    actors: ["艾登·科尔", "玛拉·文森", "卢卡斯·雷"],
    director: "诺亚·斯特林",
    description:
      "人类收到来自宇宙深处的神秘信号，一支探险队穿越虫洞寻找信号源头，却发现文明存亡的答案早已写在群星之间。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci%20fi%20movie%20poster%20of%20an%20astronaut%20facing%20a%20giant%20glowing%20planet%2C%20deep%20blue%20and%20cyan%20tones%2C%20epic%20dramatic%20lighting%2C%20no%20text&width=400&height=600&seq=cover-10002&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20space%20scene%20with%20a%20spaceship%20near%20a%20giant%20blue%20planet%20and%20nebula%2C%20dramatic%20lighting%2C%20deep%20blue%20tones%2C%20no%20text&width=1600&height=900&seq=bd-10002&orientation=landscape",
    featured: true,
  },
  {
    id: "10003",
    title: "山海秘境",
    type: "movie",
    region: "中国大陆",
    year: 2023,
    genres: ["奇幻", "冒险"],
    rating: 8.3,
    views: 987654,
    duration: "132分钟",
    actors: ["陆行舟", "苏挽月", "白宇轩"],
    director: "林牧",
    description:
      "古籍中记载的山海秘境突然现世，少年为寻回失踪的师父踏入幻境，在神兽与迷阵之间揭开了跨越千年的约定。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20movie%20poster%20of%20a%20young%20warrior%20standing%20before%20misty%20ancient%20mountains%2C%20deep%20blue%20and%20jade%20tones%2C%20epic%20lighting%2C%20no%20text&width=400&height=600&seq=cover-10003&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20fantasy%20landscape%20of%20misty%20floating%20mountains%20and%20ancient%20temples%2C%20deep%20blue%20and%20teal%20color%20grade%2C%20no%20text&width=1600&height=900&seq=bd-10003&orientation=landscape",
    featured: false,
  },
  {
    id: "10004",
    title: "城市之光",
    type: "movie",
    region: "中国香港",
    year: 2023,
    genres: ["犯罪", "悬疑"],
    rating: 8.5,
    views: 1122334,
    duration: "118分钟",
    actors: ["何家俊", "梁咏诗", "郑立行"],
    director: "杜文峰",
    description:
      "一名卧底警探游走在黑与白的边缘，当城市霓虹映照出人性的裂痕，他必须在忠诚与生存之间做出选择。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20movie%20poster%20of%20a%20man%20in%20a%20long%20coat%20in%20a%20neon%20lit%20alley%2C%20deep%20blue%20and%20amber%20tones%2C%20dramatic%20lighting%2C%20no%20text&width=400&height=600&seq=cover-10004&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20night%20view%20of%20a%20neon%20lit%20harbor%20city%2C%20deep%20blue%20and%20amber%20tones%2C%20moody%20lighting%2C%20no%20text&width=1600&height=900&seq=bd-10004&orientation=landscape",
    featured: true,
  },
  {
    id: "10005",
    title: "无声告白",
    type: "movie",
    region: "中国大陆",
    year: 2022,
    genres: ["剧情", "家庭"],
    rating: 8.9,
    views: 876543,
    duration: "121分钟",
    actors: ["方知远", "沈静", "高小满"],
    director: "许南",
    description:
      "一位沉默的父亲用二十年时间守护着不能说的秘密，直到女儿翻开旧相册，才读懂那份从未宣之于口的深爱。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%20of%20a%20father%20and%20daughter%20silhouette%20at%20dusk%2C%20warm%20deep%20blue%20tones%2C%20tender%20lighting%2C%20no%20text&width=400&height=600&seq=cover-10005&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20quiet%20riverside%20town%20at%20dusk%20with%20warm%20light%2C%20soft%20blue%20tones%2C%20no%20text&width=1600&height=900&seq=bd-10005&orientation=landscape",
    featured: false,
  },
  {
    id: "10006",
    title: "极速狂飙",
    type: "movie",
    region: "美国",
    year: 2024,
    genres: ["动作", "赛车"],
    rating: 7.8,
    views: 1567320,
    duration: "126分钟",
    actors: ["卡特·雷诺", "索菲亚·马丁", "德文·布鲁克斯"],
    director: "瑞恩·霍尔",
    description:
      "退役车手被卷入一场横跨大陆的地下竞速，油门到底的不只是引擎，还有他压抑多年的愤怒与救赎。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20action%20movie%20poster%20of%20a%20racing%20car%20with%20motion%20blur%20on%20a%20night%20highway%2C%20deep%20blue%20and%20orange%20tones%2C%20high%20energy%2C%20no%20text&width=400&height=600&seq=cover-10006&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20sports%20car%20speeding%20through%20a%20neon%20city%20tunnel%20at%20night%2C%20blue%20and%20orange%20tones%2C%20no%20text&width=1600&height=900&seq=bd-10006&orientation=landscape",
    featured: false,
  },
  {
    id: "10007",
    title: "岁月邮局",
    type: "movie",
    region: "日本",
    year: 2023,
    genres: ["爱情", "文艺"],
    rating: 8.6,
    views: 654321,
    duration: "115分钟",
    actors: ["小林悠真", "佐藤绫子", "中村健"],
    director: "山本和也",
    description:
      "海边小镇有一间能投递信件到过去的邮局，一位女子在这里写下了迟到十年的道歉，也等来了一场迟到的重逢。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20romantic%20movie%20poster%20of%20a%20young%20woman%20at%20a%20seaside%20post%20office%20at%20sunset%2C%20soft%20blue%20and%20warm%20tones%2C%20dreamy%20lighting%2C%20no%20text&width=400&height=600&seq=cover-10007&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20seaside%20town%20with%20a%20small%20post%20office%20at%20sunset%2C%20soft%20blue%20and%20golden%20tones%2C%20no%20text&width=1600&height=900&seq=bd-10007&orientation=landscape",
    featured: false,
  },
  {
    id: "10008",
    title: "荒野独行",
    type: "movie",
    region: "英国",
    year: 2022,
    genres: ["冒险", "生存"],
    rating: 8.1,
    views: 543210,
    duration: "130分钟",
    actors: ["亨利·沃德", "艾米莉亚·格林"],
    director: "奥利弗·斯通豪斯",
    description:
      "一场空难让他在无人荒原中独自求生，与风雪、饥饿和恐惧对抗的九十天，是一场关于意志的极限考验。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20survival%20movie%20poster%20of%20a%20lone%20man%20walking%20through%20a%20snowy%20wilderness%2C%20cold%20blue%20tones%2C%20harsh%20lighting%2C%20no%20text&width=400&height=600&seq=cover-10008&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20aerial%20shot%20of%20a%20vast%20snowy%20mountain%20wilderness%2C%20cold%20blue%20tones%2C%20dramatic%20light%2C%20no%20text&width=1600&height=900&seq=bd-10008&orientation=landscape",
    featured: false,
  },
  {
    id: "10009",
    title: "深海迷航",
    type: "movie",
    region: "美国",
    year: 2021,
    genres: ["科幻", "惊悚"],
    rating: 7.9,
    views: 765432,
    duration: "124分钟",
    actors: ["娜塔莉·凯恩", "马库斯·李", "伊桑·福特"],
    director: "格雷格·米勒",
    description:
      "深海钻井平台失联，救援潜艇下潜至万丈海沟，在漆黑的深渊里，他们发现真正令人恐惧的并非压力。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci%20fi%20thriller%20poster%20of%20a%20submarine%20descending%20into%20a%20dark%20ocean%20trench%2C%20deep%20blue%20and%20black%20tones%2C%20eerie%20lighting%2C%20no%20text&width=400&height=600&seq=cover-10009&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20underwater%20scene%20of%20a%20submarine%20in%20a%20deep%20dark%20ocean%20trench%20with%20light%20beams%2C%20deep%20blue%20tones%2C%20no%20text&width=1600&height=900&seq=bd-10009&orientation=landscape",
    featured: false,
  },
  {
    id: "10010",
    title: "烟火人间",
    type: "movie",
    region: "中国大陆",
    year: 2024,
    genres: ["剧情", "喜剧"],
    rating: 8.4,
    views: 1023456,
    duration: "119分钟",
    actors: ["贾大力", "刘春燕", "陈小满"],
    director: "高峰",
    description:
      "老城区的早餐店面临拆迁，一群街坊用最笨拙也最温暖的方式，守住了属于这条街的烟火与念想。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm%20drama%20movie%20poster%20of%20a%20lively%20old%20street%20breakfast%20shop%20at%20dawn%2C%20warm%20orange%20and%20blue%20tones%2C%20cozy%20lighting%2C%20no%20text&width=400&height=600&seq=cover-10010&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20busy%20old%20chinese%20street%20with%20steam%20from%20food%20stalls%20at%20dawn%2C%20warm%20tones%2C%20no%20text&width=1600&height=900&seq=bd-10010&orientation=landscape",
    featured: true,
  },
  {
    id: "10011",
    title: "王者归来",
    type: "movie",
    region: "中国大陆",
    year: 2023,
    genres: ["历史", "战争"],
    rating: 8.8,
    views: 1876543,
    duration: "152分钟",
    actors: ["赵铁山", "孙慕白", "李承渊"],
    director: "王朝",
    description:
      "乱世之中，被放逐的将军带着残部穿越千里关山，只为在故国沦陷之前，重新举起那面早已蒙尘的战旗。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20historical%20war%20movie%20poster%20of%20an%20armored%20general%20holding%20a%20banner%20on%20a%20battlefield%2C%20deep%20blue%20and%20ember%20tones%2C%20epic%20lighting%2C%20no%20text&width=400&height=600&seq=cover-10011&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20epic%20battlefield%20scene%20with%20banners%20and%20mountains%20at%20dusk%2C%20deep%20blue%20and%20orange%20tones%2C%20no%20text&width=1600&height=900&seq=bd-10011&orientation=landscape",
    featured: false,
  },
  {
    id: "10012",
    title: "灵异档案",
    type: "movie",
    region: "韩国",
    year: 2022,
    genres: ["恐怖", "悬疑"],
    rating: 7.6,
    views: 432109,
    duration: "108分钟",
    actors: ["金志勋", "朴敏雅", "崔东源"],
    director: "李在浩",
    description:
      "一档深夜灵异节目收到匿名投稿，当主持人按地址前往调查，才发现每一盘录像带都在记录着观看者自己的结局。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20horror%20movie%20poster%20of%20a%20dim%20abandoned%20room%20with%20an%20old%20television%2C%20deep%20blue%20green%20tones%2C%20creepy%20lighting%2C%20no%20text&width=400&height=600&seq=cover-10012&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20dark%20foggy%20abandoned%20house%20at%20night%2C%20cold%20blue%20green%20tones%2C%20eerie%20lighting%2C%20no%20text&width=1600&height=900&seq=bd-10012&orientation=landscape",
    featured: false,
  },
  {
    id: "20001",
    title: "权谋天下",
    type: "tv",
    region: "中国大陆",
    year: 2024,
    genres: ["古装", "权谋"],
    rating: 9.0,
    views: 3124567,
    duration: "全40集",
    actors: ["萧景珩", "柳如烟", "裴之遥"],
    director: "顾长风",
    description:
      "朝堂之上暗流涌动，一位出身寒门的谋士凭借过人的智慧步步为营，在权力与情义之间走出一条惊心动魄的血路。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20chinese%20period%20drama%20poster%20of%20an%20elegant%20scholar%20in%20dark%20robes%20in%20a%20palace%20hall%2C%20deep%20blue%20and%20gold%20tones%2C%20dramatic%20lighting%2C%20no%20text&width=400&height=600&seq=cover-20001&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20grand%20ancient%20chinese%20palace%20hall%20at%20night%20with%20lanterns%2C%20deep%20blue%20and%20gold%20tones%2C%20no%20text&width=1600&height=900&seq=bd-20001&orientation=landscape",
    featured: true,
  },
  {
    id: "20002",
    title: "都市夜归人",
    type: "tv",
    region: "中国大陆",
    year: 2024,
    genres: ["都市", "情感"],
    rating: 8.2,
    views: 1654321,
    duration: "全36集",
    actors: ["程亦凡", "夏之雨", "许知言"],
    director: "沈巍",
    description:
      "深夜便利店的灯光下，五个陌生人的人生在此交错，他们在城市的缝隙里彼此取暖，也重新定义了什么叫做家。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20poster%20of%20a%20young%20woman%20by%20a%20convenience%20store%20at%20night%2C%20deep%20blue%20and%20warm%20tones%2C%20soft%20lighting%2C%20no%20text&width=400&height=600&seq=cover-20002&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20view%20of%20a%20modern%20city%20street%20with%20lit%20shop%20windows%20at%20night%2C%20deep%20blue%20and%20warm%20tones%2C%20no%20text&width=1600&height=900&seq=bd-20002&orientation=landscape",
    featured: false,
  },
  {
    id: "20003",
    title: "破晓追凶",
    type: "tv",
    region: "中国大陆",
    year: 2023,
    genres: ["刑侦", "悬疑"],
    rating: 8.7,
    views: 2145678,
    duration: "全32集",
    actors: ["雷振东", "苏未晞", "韩立"],
    director: "岑野",
    description:
      "连环案件在破晓时分接连发生，年轻刑警与犯罪心理专家联手追凶，一步步逼近那个藏在迷雾后的真相。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20drama%20poster%20of%20two%20detectives%20under%20street%20lamps%20at%20dawn%2C%20deep%20blue%20tones%2C%20moody%20lighting%2C%20no%20text&width=400&height=600&seq=cover-20003&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20foggy%20city%20bridge%20at%20dawn%20with%20blue%20light%2C%20moody%20tones%2C%20no%20text&width=1600&height=900&seq=bd-20003&orientation=landscape",
    featured: true,
  },
  {
    id: "20004",
    title: "星辰大海",
    type: "tv",
    region: "中国大陆",
    year: 2024,
    genres: ["科幻", "青春"],
    rating: 8.0,
    views: 1234567,
    duration: "全30集",
    actors: ["江星辰", "林浩宇", "苏念"],
    director: "陆远征",
    description:
      "一群航天学院的热血少年，在严苛训练与彼此扶持中成长，用青春丈量从地面到星辰的距离。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20youth%20scifi%20drama%20poster%20of%20young%20cadets%20looking%20at%20a%20starry%20sky%2C%20deep%20blue%20and%20cyan%20tones%2C%20hopeful%20lighting%2C%20no%20text&width=400&height=600&seq=cover-20004&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20rocket%20launch%20pad%20under%20a%20vast%20starry%20night%20sky%2C%20deep%20blue%20tones%2C%20no%20text&width=1600&height=900&seq=bd-20004&orientation=landscape",
    featured: false,
  },
  {
    id: "20005",
    title: "厨房里的春天",
    type: "tv",
    region: "日本",
    year: 2023,
    genres: ["美食", "治愈"],
    rating: 8.5,
    views: 987654,
    duration: "全24集",
    actors: ["森川结衣", "高桥凉介", "田中美咲"],
    director: "藤井悠",
    description:
      "一间不起眼的小食堂，一位沉默寡言的厨娘，用一道道家常菜抚平了每个走进门来的疲惫灵魂。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm%20food%20drama%20poster%20of%20a%20cozy%20small%20restaurant%20kitchen%20with%20steam%2C%20warm%20amber%20and%20blue%20tones%2C%20soft%20lighting%2C%20no%20text&width=400&height=600&seq=cover-20005&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20cozy%20japanese%20restaurant%20interior%20at%20night%2C%20warm%20amber%20and%20blue%20tones%2C%20no%20text&width=1600&height=900&seq=bd-20005&orientation=landscape",
    featured: false,
  },
  {
    id: "20006",
    title: "王座之争",
    type: "tv",
    region: "美国",
    year: 2022,
    genres: ["奇幻", "史诗"],
    rating: 8.9,
    views: 2765432,
    duration: "全20集",
    actors: ["奥兰多·布莱克", "伊莎贝拉·诺曼", "卡尔·文森"],
    director: "大卫·桑德斯",
    description:
      "七大王国的王座空悬，龙焰与寒铁交织的史诗中，每一个家族都在为权力押上最后的筹码。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20epic%20fantasy%20drama%20poster%20of%20a%20crowned%20ruler%20on%20an%20iron%20throne%2C%20deep%20blue%20and%20gold%20tones%2C%20dramatic%20lighting%2C%20no%20text&width=400&height=600&seq=cover-20006&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20epic%20fantasy%20landscape%20of%20a%20vast%20castle%20and%20mountains%20under%20a%20dramatic%20sky%2C%20deep%20blue%20and%20gold%20tones%2C%20no%20text&width=1600&height=900&seq=bd-20006&orientation=landscape",
    featured: false,
  },
  {
    id: "20007",
    title: "医者仁心",
    type: "tv",
    region: "中国大陆",
    year: 2023,
    genres: ["医疗", "剧情"],
    rating: 8.3,
    views: 1432109,
    duration: "全42集",
    actors: ["沈知白", "陆清和", "安嘉宁"],
    director: "谭一鸣",
    description:
      "急诊科的白炽灯永不停歇，一群医生在生死线上争分夺秒，也在一次次抉择中淬炼着职业与人性。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20medical%20drama%20poster%20of%20a%20doctor%20in%20a%20bright%20hospital%20corridor%2C%20clean%20blue%20and%20white%20tones%2C%20dramatic%20lighting%2C%20no%20text&width=400&height=600&seq=cover-20007&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20modern%20hospital%20emergency%20room%20at%20night%2C%20clean%20blue%20tones%2C%20no%20text&width=1600&height=900&seq=bd-20007&orientation=landscape",
    featured: false,
  },
  {
    id: "20008",
    title: "江湖客栈",
    type: "tv",
    region: "中国大陆",
    year: 2024,
    genres: ["武侠", "喜剧"],
    rating: 7.9,
    views: 876543,
    duration: "全28集",
    actors: ["柳随风", "花千树", "赵小刀"],
    director: "莫千里",
    description:
      "一间开在官道边的客栈，迎来送往的都是江湖客，老板一边盘账一边化解麻烦，笑声里藏着的是侠义与温情。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20wuxia%20comedy%20drama%20poster%20of%20a%20lively%20ancient%20inn%20at%20night%20with%20lanterns%2C%20deep%20blue%20and%20warm%20tones%2C%20playful%20lighting%2C%20no%20text&width=400&height=600&seq=cover-20008&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20an%20ancient%20chinese%20inn%20by%20a%20road%20at%20night%20with%20lanterns%2C%20deep%20blue%20and%20warm%20tones%2C%20no%20text&width=1600&height=900&seq=bd-20008&orientation=landscape",
    featured: false,
  },
];